import { showErrorAlert } from 'actions';
import Modal from 'components/Modal';
import useUpsertInvestigation from 'hooks/investigations/useUpsertInvestigation';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

type ComponentProps = {
  isModalOpen: boolean;
  toggleModalOpen: () => void;
  onCreated: () => void;
};

const CreateInvestigationModal: React.FC<ComponentProps> = ({
  isModalOpen,
  toggleModalOpen,
  onCreated,
}) => {
  const dispatch = useDispatch();
  const { mutateAsync, isLoading } = useUpsertInvestigation();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [discoverId, setDiscoverId] = useState('');

  const reset = (): void => {
    setName('');
    setDescription('');
    setDiscoverId('');
  };

  const handleClose = (): void => {
    reset();
    toggleModalOpen();
  };

  const handleSubmit = async (): Promise<void> => {
    const trimmed = name.trim();
    if (!trimmed) {
      dispatch(showErrorAlert('Name is required'));
      return;
    }
    await mutateAsync({
      name: trimmed,
      description: description.trim() || undefined,
      discover_id: discoverId.trim() || undefined,
    });
    reset();
    toggleModalOpen();
    onCreated();
  };

  const body = (
    <div className="flex flex-col gap-4 mb-4 h-full text-body">
      <label className="flex flex-col gap-1" htmlFor="investigation-create-name">
        <span>
          Name<span className="text-litlingo-alert">*</span>
        </span>
        <input
          id="investigation-create-name"
          type="text"
          className="form-input h-8 w-full text-litlingo-gray-6 text-body"
          value={name}
          onChange={(e): void => setName(e.target.value)}
        />
      </label>
      <label className="flex flex-col gap-1" htmlFor="investigation-create-desc">
        <span>Description</span>
        <textarea
          id="investigation-create-desc"
          rows={3}
          className="form-input w-full text-litlingo-gray-6 text-body"
          value={description}
          onChange={(e): void => setDescription(e.target.value)}
        />
      </label>
      <label className="flex flex-col gap-1" htmlFor="investigation-create-discover">
        <span>Discover ID</span>
        <input
          id="investigation-create-discover"
          type="text"
          className="form-input h-8 w-full text-litlingo-gray-6 text-body"
          value={discoverId}
          onChange={(e): void => setDiscoverId(e.target.value)}
        />
      </label>
    </div>
  );

  return (
    <>
      {isModalOpen && (
        <Modal
          title="New investigation"
          body={body}
          toggleShowModal={handleClose}
          style={{ width: '37.5rem' }}
          okButton
          okButtonText="Create"
          okButtonDisabled={!name.trim() || isLoading}
          okButtonOnClick={(): void => {
            handleSubmit().catch(() => undefined);
          }}
          cancelButton
          cancelButtonOnclick={handleClose}
          xButton
          loading={isLoading}
        />
      )}
    </>
  );
};

export default CreateInvestigationModal;
